<template>
  <div class="invitation">
    <el-form class="form" ref="form" :model="form" label-width="80px">
      <el-form-item label="标题">
        <el-input v-model="form.title" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="封面">
        <!-- <el-input v-model="form.thumb" style="width:400px"></el-input> -->
        <img class="thumb-img" v-if="form.thumb" :src="form.thumb" @click="selectThumb('thumb')">
        <el-button v-else size="small" @click="selectThumb('thumb')">选择图片</el-button>
      </el-form-item>
      <el-form-item label="时间">
        <el-input v-model="form.time" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="地点">
        <el-input v-model="form.address" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="显示价格">
        <el-input v-model="form.price" placeholder="免费则不填此项" style="width:400px"></el-input>
      </el-form-item>
      <el-form-item label="预约内容">
        <edit-box></edit-box>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="next">下一步</el-button>
      </el-form-item>
    </el-form>
    <upload-img ref="upload"></upload-img>
  </div>
</template>
<script>
import VueUEditor from 'vue-ueditor'
import UploadImg from '@/components/UploadImg'
import editBox from '@/views/pages/components/editBox'
export default {
  name: 'invitation',
  components: {
    UploadImg,
    VueUEditor,
    editBox
  },
  props: {
    form: {
      type: Object
    },
    uuid: {
      type: String
    }
  },
  watch: {
    form: {
      handler (value, oldValue) {
        this.$store.commit('SET_PAGE', this.form.page)
        // this.initCreateData()
      },
      immediate: true,
      deep: true
    }
  },
  created () {
    this.initCreateData()
  },
  methods: {
    initCreateData () {
      this.$store.commit('SET_PAGE', this.form.page)
      this.$store.commit('SET_PAGE_CURRENTITEM', '')
    },
    selectThumb (key) {
      let list = []
      if (this.form[key]) {
        list = [this.form[key]]
      }
      this.$refs.upload.show(list, 'other', 1).then(res => {
        if (res.length) {
          this.form[key] = res[0]
        }
      }).catch(_ => {})
    },
    next () {
      this.$emit('next')
    }
  }
}
</script>
<style lang="less" scoped>
.invitation {
  .thumb-img {
    cursor: pointer;
    height: 60px;
    width: auto;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/booking/components/invitation.vue